import React, {useEffect, useState } from 'react';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';

const AnimatedBackground = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  return (
    <div className="fixed inset-0 z-[-1] overflow-hidden bg-white pointer-events-none">
      {init && (
        <Particles
          id="tsparticles"
          options={{
            background: { color: { value: "transparent" } },
            fpsLimit: 60,
            interactivity: {
              events: {
                onHover: { enable: true, mode: "grab" },
                resize: true,
              },
              modes: {
                grab: { distance: 150, links: { opacity: 0.3 } },
              },
            },
            particles: {
              color: { value: "#cbd5e1" }, // slate-300
              links: {
                color: "#e2e8f0", // slate-200
                distance: 150,
                enable: true,
                opacity: 0.6,
                width: 1,
              },
              move: {
                enable: true,
                speed: 1.2,
                direction: "none",
                random: false,
                straight: false,
                outModes: { default: "bounce" },
              },
              number: {
                density: { enable: true, area: 800 },
                value: 50,
              },
              opacity: { value: 0.5 },
              shape: { type: "circle" },
              size: { value: { min: 1, max: 2 } },
            },
            detectRetina: true,
          }}
        />
      )}
      
      {/* Decorative gradient overlay */}
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-br from-blue-50 to-transparent blur-3xl opacity-50 mix-blend-multiply"></div>
      <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-gradient-to-tr from-indigo-50 to-transparent blur-3xl opacity-50 mix-blend-multiply"></div>
    </div>
  );
};

export default AnimatedBackground;
